export const getAPIKey = (): string | null => localStorage.getItem("api-key");
